import { render, staticRenderFns } from "./BagModal.vue?vue&type=template&id=8932ada0&"
import script from "./BagModal.vue?vue&type=script&lang=ts&"
export * from "./BagModal.vue?vue&type=script&lang=ts&"
import style0 from "./BagModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports